"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../CTAs/Link"));

var _usePagination2 = require("./usePagination");

var _excluded = ["ariaLabel", "baseUrl", "classes", "currentPage", "dataTestId", "onPageChange", "resultsPerPage", "showPageCount", "siblingCount", "totalResults"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pagination = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      baseUrl = _ref.baseUrl,
      classes = _ref.classes,
      currentPage = _ref.currentPage,
      dataTestId = _ref.dataTestId,
      onPageChange = _ref.onPageChange,
      resultsPerPage = _ref.resultsPerPage,
      showPageCount = _ref.showPageCount,
      siblingCount = _ref.siblingCount,
      totalResults = _ref.totalResults,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _usePagination = (0, _usePagination2.usePagination)({
    totalResults: totalResults,
    resultsPerPage: resultsPerPage,
    siblingCount: siblingCount,
    currentPage: currentPage
  }),
      paginationRange = _usePagination.paginationRange,
      leftSkippedPages = _usePagination.leftSkippedPages,
      rightSkippedPages = _usePagination.rightSkippedPages,
      onlyLeft = _usePagination.leftOnlySkippedPages,
      onlyRight = _usePagination.rightOnlySkippedPages;

  var nextPage = currentPage + 1;
  var prevPage = currentPage - 1;

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  /* eslint no-param-reassign: "error" */


  function clearArray(arr) {
    arr.length = 0;
  }

  var onNext = function onNext() {
    onPageChange(nextPage);
    clearArray(leftSkippedPages);
    clearArray(rightSkippedPages);
    clearArray(onlyLeft);
    clearArray(onlyRight);
  };

  var onPrevious = function onPrevious() {
    onPageChange(prevPage);
    clearArray(leftSkippedPages);
    clearArray(rightSkippedPages);
    clearArray(onlyLeft);
    clearArray(onlyRight);
  };

  var lastPage = paginationRange[paginationRange.length - 1];
  var resultsStartRange = currentPage * resultsPerPage - resultsPerPage + 1;

  var totalPages = function totalPages() {
    return Math.round(totalResults / resultsPerPage);
  };

  function resultsRange() {
    if (currentPage === 1) {
      return "".concat(currentPage, " - ").concat(resultsPerPage);
    }

    if (currentPage === lastPage) {
      return "".concat(resultsStartRange, " - ").concat(totalResults);
    }

    return "".concat(resultsStartRange, " - ").concat(currentPage * resultsPerPage);
  }

  function currentPageOf(pageNumber) {
    if (currentPage === pageNumber) {
      return "Current page ".concat(pageNumber, " of ").concat(totalPages());
    }

    return "Go to page ".concat(pageNumber, " of ").concat(totalPages());
  }

  return /*#__PURE__*/_react.default.createElement("nav", _extends({
    "aria-label": ariaLabel,
    role: "navigation",
    className: (0, _classnames.default)("pagination", classes),
    "data-testid": dataTestId,
    ref: ref
  }, additionalProps), /*#__PURE__*/_react.default.createElement("ul", {
    className: "pagination__list"
  }, currentPage > 1 && /*#__PURE__*/_react.default.createElement("li", {
    className: "pagination__prev-next--display"
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    dataTestId: "paginationPrevious",
    href: baseUrl + prevPage.toString(),
    clickMethod: onPrevious,
    text: "Previous",
    variant: "text-alternate",
    size: "medium",
    icon: "IconChevronLeft",
    iconPosition: "left",
    ariaLabel: "Go to page ".concat(prevPage, " of ").concat(totalPages())
  })), paginationRange === null || paginationRange === void 0 ? void 0 : paginationRange.map(function (pageNumber, index) {
    if (pageNumber === _usePagination2.ellipses) {
      if (index === 1 && leftSkippedPages.length) {
        var lastElement = leftSkippedPages.slice(-1)[0];
        if (leftSkippedPages.length === 1) return /*#__PURE__*/_react.default.createElement("li", {
          className: "pagination__ellipses",
          key: "".concat(pageNumber, "-").concat(index) // eslint-disable-line

        }, "\u2026", /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Pages ".concat(leftSkippedPages[0], " skipped")));
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "pagination__ellipses",
          key: "".concat(pageNumber, "-").concat(index) // eslint-disable-line

        }, "\u2026", /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Pages ".concat(leftSkippedPages[0], " - ").concat(lastElement, " skipped")));
      }

      if (index === 5 && rightSkippedPages.length) {
        var _lastElement = rightSkippedPages.slice(-1)[0];
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "pagination__ellipses",
          key: "".concat(pageNumber, "-").concat(index) // eslint-disable-line

        }, "\u2026", /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Pages ".concat(rightSkippedPages[0], " - ").concat(_lastElement, " skipped")));
      }

      return /*#__PURE__*/_react.default.createElement("li", {
        className: "pagination__ellipses",
        key: "".concat(pageNumber, "-").concat(index) // eslint-disable-line

      }, "\u2026", onlyLeft.length ? /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Pages ".concat(onlyLeft[0], " - ").concat(onlyLeft[1], " skipped")) : onlyRight.length ? /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Pages ".concat(onlyRight[0], " - ").concat(onlyRight[1], " skipped")) : null);
    }

    return /*#__PURE__*/_react.default.createElement("li", {
      key: pageNumber
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: baseUrl + pageNumber.toString(),
      clickMethod: function clickMethod() {
        clearArray(leftSkippedPages);
        clearArray(rightSkippedPages);
        clearArray(onlyLeft);
        clearArray(onlyRight);
        onPageChange(pageNumber);
      },
      text: pageNumber.toString(),
      variant: "text-alternate",
      size: "medium",
      classes: currentPage === pageNumber ? 'cta--active' : '',
      ariaLabel: "".concat(currentPageOf(pageNumber)),
      "aria-current": currentPage === pageNumber
    }));
  }), currentPage === lastPage || /*#__PURE__*/_react.default.createElement("li", {
    className: "pagination__prev-next--display"
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    dataTestId: "paginationNext",
    href: baseUrl + nextPage.toString(),
    clickMethod: onNext,
    text: "Next",
    variant: "text-alternate",
    size: "medium",
    icon: "IconChevronRight",
    iconPosition: "right",
    ariaLabel: "Go to page ".concat(nextPage, " of ").concat(totalPages())
  }))), showPageCount && /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination__page-count"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "pagination__page"
  }, resultsRange(), " of ", totalResults, " items")));
});
Pagination.propTypes = {
  /**
   Required. String passed to nav element's aria-label attribute. Announces pagination context to screen-reader users. eg: 'Search results pagination'.
   */
  ariaLabel: _propTypes.default.string.isRequired,

  /**
   Required. URL to append the pagination number to.
   */
  baseUrl: _propTypes.default.string.isRequired,

  /**
   Optional. String to add custom class(es) to the component. Defaults to `null`.
   */
  classes: _propTypes.default.string,

  /**
   Required: Implementation-level local state value passed in so the component knows what the active page is.
   */
  currentPage: _propTypes.default.number.isRequired,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Required: Function passed in allowing the component to update the current page value.
   */
  onPageChange: _propTypes.default.func.isRequired,

  /**
   Sets the number of results displayed on the page.
   */
  resultsPerPage: _propTypes.default.number.isRequired,

  /**
   Optional. Updates the amount of links displayed on either side of the active page link. Defaults to 1.
   */
  siblingCount: _propTypes.default.number,

  /**
   Optional. Displays the results range and total results count if set to true. Defaults to false.
   */
  showPageCount: _propTypes.default.bool,

  /**
   Required. Allows the component to determine the total number of page links to display. Typically equal to data.length.
   */
  totalResults: _propTypes.default.number.isRequired
};
Pagination.defaultProps = {
  classes: null,
  dataTestId: null,
  showPageCount: false,
  siblingCount: 1
};
Pagination.displayName = 'Pagination';
var _default = Pagination;
exports.default = _default;